import script from "./dich-vu-theo-khung-gio.vue?vue&type=script&setup=true&lang=js"
export * from "./dich-vu-theo-khung-gio.vue?vue&type=script&setup=true&lang=js"

import "./dich-vu-theo-khung-gio.vue?vue&type=style&index=0&id=78089986&scoped=true&lang=css"
/* custom blocks */
import block0 from "./dashboard.scss?vue&type=custom&index=0&blockType=link&issuerPath=D%3A%5Cvsts-agent%5C_work%5C53%5Cs%5Csrc%5Cviews%5Ckhach-hang%5Cdich-vu-theo-khung-gio%5Cdich-vu-theo-khung-gio.vue"
if (typeof block0 === 'function') block0(script)


import exportComponent from "D:\\vsts-agent\\_work\\53\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78089986"]])

export default __exports__